import React from 'react';
import '../../output.css';
import novoville_logo from '../../resources/novoville_logo.svg';
import AuthHeader from '../AuthHeader/AuthHeader';

const AuthPageContainer = ({
  children,
  language,
  handleLanguageChange,
  fullWidthContent = false,
}) => {
  return (
    <div className="flex flex-wrap bg-white">
      <div className="h-[400vh] w-full min-h-[100vh] bg-white overflow-hidden fixed" />
      <AuthHeader
        key={language}
        logo={novoville_logo}
        handleLanguageChange={handleLanguageChange}
      />
      <div className="min-h-[calc(100vh-100px)] w-screen flex flex-col justify-center sm:py-[74px] py-[24px] sm:px-8">
        <div
          className={`w-full h-full ${
            fullWidthContent ? 'flex flex-1' : 'md:h-fit max-w-md self-center'
          }`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthPageContainer;
